/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import {
    requestCreateSpace,
    requestUpdateSpaceById
} from "services/settings/spaceAdmin/aboutSpaceAdmin";
import { FORM_ACTION_ERRORS } from "views/Configuracion/SettingsSpaceAdmin/components/RegisterSpaceForm/utils/constants";
import useMainContext from "utils/context/useMainContext";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";

const useSaveChangesForm = ({
    loadingRequest, preselectedData, spaceSelected,
    form, onSuccessCreate, onSuccessUpdate
}) => {
    //#region Effects
    useEffect(() => {
        if (!spaceSelected.value)
            setPreselectedData();
    }, [spaceSelected.value, preselectedData]);
    useEffect(() => {
        if (spaceSelected.isEmpty()) return;
        form.update(spaceSelected.value);
    }, [spaceSelected.value]);
    //#endregion
    //#region Custom Hooks
    const mainContext = useMainContext();
    const dialogConfirmUpdate = useShowDialogAlert();
    const dialogErrorForFutureReservationsInEdition = useShowDialogAlert();
    //#endregion
    //#region Functions
    function setPreselectedData() {
        if (preselectedData)
            form.update(preselectedData);
    }
    async function saveSpace({ loadingText, request, onSuccess }) {
        loadingRequest.show(`${loadingText} espacio...`);
        const { success, message } = await request(form.value);
        loadingRequest.hide();
        if (success) {
            onSuccess(form.value);
            return;
        }
        switch (message) {
            case FORM_ACTION_ERRORS.FUTURE_RESERVATIONS:
                dialogErrorForFutureReservationsInEdition.open();
                return;
            default:
                mainContext.setShowDialogUnexpectedError(true);
        }
    }
    async function createSpace() {
        saveSpace({
            loadingText: "Creando",
            request: requestCreateSpace,
            onSuccess: onSuccessCreate
        });
    }
    async function updateSpace() {
        dialogConfirmUpdate.hide();
        saveSpace({
            loadingText: "Editando",
            request: requestUpdateSpaceById,
            onSuccess: onSuccessUpdate
        });
    }

    function saveChanges() {
        if (!spaceSelected.isEmpty())
            dialogConfirmUpdate.open();
        else createSpace();
    }
    //#endregion
    return {
        saveChanges,
        createSpace,
        updateSpace,
        dialogs: {
            dialogConfirmUpdate,
            dialogErrorForFutureReservationsInEdition
        }
    };
}

export default useSaveChangesForm;